// extracted by mini-css-extract-plugin
export default {"loading":"LoadingLogo_loading__njpVt","logo":"LoadingLogo_logo__FITUt","spin180":"LoadingLogo_spin180__hEKxB"};